import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.status == _ctx.orderStatus.PartsOrdering)
      ? (_openBlock(), _createBlock(_component_el_tag, {
          key: 0,
          size: _ctx.tagSize,
          type: "warning",
          class: "filled",
          effect: "plain"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Заказ запчастей")
          ]),
          _: 1
        }, 8, ["size"]))
      : _createCommentVNode("", true),
    (_ctx.status == _ctx.orderStatus.PartsAwaiting)
      ? (_openBlock(), _createBlock(_component_el_tag, {
          key: 1,
          size: _ctx.tagSize,
          type: "warning",
          class: "filled",
          effect: "plain"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Ожидание запчастей")
          ]),
          _: 1
        }, 8, ["size"]))
      : _createCommentVNode("", true),
    (_ctx.status == _ctx.orderStatus.VisitNegotiating)
      ? (_openBlock(), _createBlock(_component_el_tag, {
          key: 2,
          size: _ctx.tagSize,
          type: "warning",
          class: "filled",
          effect: "plain"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Согласование визита")
          ]),
          _: 1
        }, 8, ["size"]))
      : _createCommentVNode("", true),
    (_ctx.status == _ctx.orderStatus.VisitAwaiting)
      ? (_openBlock(), _createBlock(_component_el_tag, {
          key: 3,
          size: _ctx.tagSize,
          type: "primary",
          class: "filled",
          effect: "plain"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Ожидание визита")
          ]),
          _: 1
        }, 8, ["size"]))
      : _createCommentVNode("", true),
    (_ctx.status == _ctx.orderStatus.VehicleAccepted)
      ? (_openBlock(), _createBlock(_component_el_tag, {
          key: 4,
          size: _ctx.tagSize,
          type: "primary",
          class: "filled",
          effect: "plain"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Автомобиль принят")
          ]),
          _: 1
        }, 8, ["size"]))
      : _createCommentVNode("", true),
    (_ctx.status == _ctx.orderStatus.VehicleInProgress)
      ? (_openBlock(), _createBlock(_component_el_tag, {
          key: 5,
          size: _ctx.tagSize,
          type: "primary",
          class: "filled",
          effect: "plain"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Выполнение работ")
          ]),
          _: 1
        }, 8, ["size"]))
      : _createCommentVNode("", true),
    (_ctx.status == _ctx.orderStatus.ExtraNegotiating)
      ? (_openBlock(), _createBlock(_component_el_tag, {
          key: 6,
          size: _ctx.tagSize,
          type: "warning",
          class: "filled",
          effect: "plain"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Доп. согласование")
          ]),
          _: 1
        }, 8, ["size"]))
      : _createCommentVNode("", true),
    (_ctx.status == _ctx.orderStatus.VehicleCompleted)
      ? (_openBlock(), _createBlock(_component_el_tag, {
          key: 7,
          size: _ctx.tagSize,
          type: "success",
          class: "filled",
          effect: "plain"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Работы выполнены")
          ]),
          _: 1
        }, 8, ["size"]))
      : _createCommentVNode("", true),
    (_ctx.status == _ctx.orderStatus.Closed)
      ? (_openBlock(), _createBlock(_component_el_tag, {
          key: 8,
          size: _ctx.tagSize,
          effect: "plain",
          type: "info",
          class: "filled"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Закрыт")
          ]),
          _: 1
        }, 8, ["size"]))
      : _createCommentVNode("", true)
  ], 64))
}